import graphqlClient from "../../../apollo";

class LocalityProvider {

    findLocality(id) {
        return graphqlClient.query({
            query: require('./gql/Locality/findLocality.graphql'),
            variables: {id:id}
        })
    }

    fetchLocality() {
        return graphqlClient.query({
            query: require('./gql/Locality/fetchLocality.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateLocality(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Locality/paginateLocality.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createLocality(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Locality/createLocality.graphql'),
            variables: {input}
        })
    }

    updateLocality(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Locality/updateLocality.graphql'),
            variables: {id, input}
        })
    }

     deleteLocality(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Locality/deleteLocality.graphql'),
            variables: {id}
        })
    }

}

export default new LocalityProvider()


